import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTextBoxModule, DxDropDownBoxModule, DxCheckBoxModule } from 'devextreme-angular';
import { NgIf, NgSwitch, AsyncPipe, NgFor } from '@angular/common';
import { DropDownDatasourceRow } from '../../interfaces/dropdown-datasource-row.interface';

@Component({
    selector: 'multiselect-dropdown',
    templateUrl: './multiselect-dropdown.component.html',
    styleUrls: ['./multiselect-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgSwitch,
		NgFor,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
		DxDropDownBoxModule,
		DxCheckBoxModule,
        AsyncPipe,
    ],
})
export class MultiselectDropdownComponent {
	@Input()
	dataSource: DropDownDatasourceRow[];

	constructor(private cdr: ChangeDetectorRef) {

	}

	onDropdownSelectionChanged($event, row: DropDownDatasourceRow) {
		row.selected = $event.value;
		this.cdr.detectChanges();

		// this.valueChanged.emit(JSON.stringify(this.selectedValues));
	}

	getTextBoxValue() {
		return `${this.dataSource.filter(d => d.selected).length} selected.`;
	}
}
